<template>
  <div class="container">
    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h1 class="titulo m-t-2 m-t-3-md">Producción de gas nacional</h1>

      <hr>

      <p class="texto-principal">La producción nacional de gas tocó su pico máximo en 2009. Desde entonces la producción se ha reducido a dos terceras partes.</p>

    </div>
    <div>

    <div class="tarjeta-contenedor">
          <div class="encabezado">
            <h3>Producción de gas</h3>
            <p class="texto-notas">Datos en miles de millones de pies cubicos diarios (MMMPCD). Actualización: 2022</p>
          </div>
          <div class="contenido">
            <div class="barrasProduccion" ref="barrasProduccion">
            </div>
          </div>
          <div class="tarjeta-contendor-notas">
              <p class="texto-notas"></p>
          </div>
      </div>

    </div>

    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">

      <p class="texto-primario">Entre 1960 y 2022 el 33% de la producción de gas provino de la porción marina de Cuencas del Sureste. Por su parte la provincia de Burgos (terrestres) aportó el 17% del total de la producción. Entre 1975 y 1978 el campo terrestre Samaria aportó más del 10% de la producción de gas. Entre 1972 y 1982 los campos marinos petroleros Abkatún y Akal, representaron el 17% de la producción de gas y los campos terrestres Agave y Giraldas el 18% de la producción gas.
Para el periodo 1998-1999 se incrementa la producción de gas de los campos marinos Akal y Can, que aportan el 17%. Entre 2004 y 2009 con la declinación de la producción de petróleo de los campos May, Ku, Caan y Zaap, se incrementa la producción de gas. Finalmenete, entre 2009 y 2021 el agotamiento petrolero de los campos Akal, Ku, Maloob y Zaap se refleja en el aporte del 40% de la producción de gas.</p>

    </div>
    
    <div>
      <dai-tarjeta-contenedor-mapa :permitir-colapso="true" altura-colapsada="80vh">
      
      <template v-slot:header>
            <h3>Distribución de las Producción de Gas por Provincia Petrolera</h3> 

          

            <p class="texto-notas " v-width-control="'100%'" >Miles de millones de pies cubicos diarios (MMMPCD). Actualización: 2022.</p>
            
            <dai-leyenda-mapa v-show="selectorCategoria==='1p'"
            titulo="Producción de gas (MMMPC)"
            :para="['distribucion_reserva_provincia_petrolera_1p']"
            />


      </template>

      <dai-mapa
      :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
      >
          
      <dai-capa-xyz url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>


      <dai-capa-geojson :visible="selectorCategoria==='1p'"
      id="distribucion_reserva_provincia_petrolera_1p"
      titulo="Producción de gas"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Producción:</b> ${feat.GAS_TOTAL_MMPCD_} MMPCD`"
      url="../geodata/hidrocarburos/produccion2020.geojson"
      :reglas-estilo-capa="[
        {
            clasificacion:'categorias',
            columna : 'PROV_PETRO',
            acomodoCategorias:['Burgos','Cinturon Plegado de Chiapas','Cuencas del Sureste','Golfo de Mexico Profundo','Licitaciones','Plataforma Burro-Picachos','Sabinas','Tampico-Misantla','Veracruz'],
            propiedadObjetivo: 'relleno',
            colores:['#02c620','#c25737','#dd2a60','#39d0d5','#d1308b','#b323cc','#cce187','#d91ac9','#dd9211'],
            tituloVariable:'Provincia petrolera'
        },
        {
            clasificacion:'personalizada',
            columna:'GAS_TOTAL_MMPCD_',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,25],[25,100],[100,250],[250,500],[500,1090]],
            proporciones:[0,4,6,8,10,15],
            clases:5,
            tituloVariable:'Miles de millones de pies cúbicos diarios'
        }
      ]"
      />

  
      </dai-mapa>


      </dai-tarjeta-contenedor-mapa>

      <br>


    <div class="tarjeta-contenedor">
          <div class="encabezado">
            <h3>Producción de gas por ubicación</h3>
            <p class="texto-notas">Datos en miles de millones de pies cubicos diarios (MMMPCD). Actualización: 2022</p>
          </div>
          <div class="contenido">
            <div class="barrasProduccionUbicacion" ref="barrasProduccionUbicacion">
            </div>
          </div>
          <div class="tarjeta-contendor-notas">
              <p class="texto-notas"></p>
          </div>
      </div>

      
    </div>

    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">

      <p class="texto-principal">El siguiente mapa interactivo permite visualizar la producción de gas por cada campo en 2022. En ese año la Provincia Cuencas del Sureste, aportó el 79% de la producción de gas, 55% en la porción marina (Akal, Ku, Maloob y Zaap) y 25% en la porción terrestre. Por su parte la provincia de Burgos representó el 10% de la producción nacional.</p>
    
    </div>

    <div>
      
      <dai-tarjeta-contenedor-mapa :permitir-colapso="false" altura-colapsada="400vh">
      
      <template v-slot:header>
            <h3>Distribución de las Producción por Campo</h3> 

          
            <dai-buscador-mapa 
            para="distribucion_campo_petrolero_1p"
            :acceso-opciones="(f)=>f.CAMPO"
            placeholder="Buscar campo"
            />

            <p class="texto-notas " v-width-control="'100%'" >Miles de millones de pies cubicos diarios (MMMPCD). Actualización: 2022.</p>
            
            <dai-leyenda-mapa v-show="selectorCategoriaCampo==='1p'"
            titulo="Producción de gas (MMMPC)"
            :para="['distribucion_campo_petrolero_1p']"
            />


      </template>

      <dai-mapa
      :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
      >
          
      <dai-capa-xyz url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>


      <dai-capa-geojson :visible="selectorCategoriaCampo==='1p'"
      id="distribucion_campo_petrolero_1p"
      titulo="Producción de gas"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Producción:</b> ${feat.GAS_TOTAL_MMPCD_} MMPCD`"
      url="../geodata/hidrocarburos/produccion2020.geojson"
      :reglas-estilo-capa="[
        /*{
            clasificacion:'categorias',
            columna : 'CAMPO',
            propiedadObjetivo: 'relleno',
            tituloVariable:'Campo'
        },*/
        {
          clasificacion:'personalizada',
            columna:'GAS_TOTAL_MMPCD_',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,25],[25,100],[100,250],[250,500],[500,1090]],
            proporciones:[0,4,6,8,10,15],
            clases:5,
            tituloVariable:'Miles de millones de pies cúbicos diarios'
        }
      ]"
      />

  
      </dai-mapa>


      </dai-tarjeta-contenedor-mapa>


    </div>

    <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
              <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
              <ul class="lista-referencias">
                <li><em><strong>Comisión Nacional de Hidrocarburos (CNH) (2022).</strong></em> Reporte de la Cuantificación y Certificación de las Reservas de la Nación del año 2022. <a href="https://www.gob.mx/cnh/acciones-y-programas/cuantificacion-y-certificacion-de-reservas" target="_blank">https://www.gob.mx/cnh/acciones-y-programas/cuantificacion-y-certificacion-de-reservas</a></li>
              </ul>            
          </div>

  </div>
</template>
<script>
  
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import am4lang_es_ES from "@amcharts/amcharts4/lang/es_ES";
  import am4themes_kelly from "@amcharts/amcharts4/themes/kelly";

  am4core.useTheme(am4themes_kelly);
  

  export default {
    name: 'App',
    components: {
    },
    data: function () {
      return {
        selectorCategoria:'1p',
        selectorCategoriaCampo:'1p',
        produccionDatos:produccionDatos,
        produccionVariables: produccionVariables,
        produccionUbicacionDatos: produccionUbicacionDatos,
        produccionUbicacionVariables: produccionUbicacionVariables,
      }   
    },
    methods:{
        cambioSelector:function(e){
            
        },
    },
    mounted() {

      //Producción
      let chartProduccion = am4core.create(this.$refs.barrasProduccion, am4charts.XYChart);
      chartProduccion.language.locale = am4lang_es_ES;
      chartProduccion.language.locale["_decimalSeparator"] = ".";
      chartProduccion.language.locale["_thousandSeparator"] = ",";
      chartProduccion.exporting.menu = new am4core.ExportMenu();
      chartProduccion.exporting.filePrefix = "ProduccionGas";
      chartProduccion.exporting.useWebFonts = false;

      chartProduccion.maskBullets = false;
      chartProduccion.paddingLeft = 20;
      chartProduccion.paddingRight = 50;
      chartProduccion.fontSize = 12;

      chartProduccion.data = produccionDatos;

      // Create axes
      let categoryAxis3 = chartProduccion.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis3.dataFields.category = "a";
      categoryAxis3.renderer.grid.template.location = 0;
      categoryAxis3.renderer.minGridDistance = 35;
      categoryAxis3.baseInterval = {
                    timeUnit: "year",
                    count: 5
      };

      let valueAxis3 = chartProduccion.yAxes.push(new am4charts.ValueAxis());
      //valueAxis3.renderer.inside = true;
      //valueAxis3.renderer.labels.template.disabled = true;
      valueAxis3.title.text = "MMMPC";
      valueAxis3.min = 0;
      valueAxis3.extraMax = 0.1;
      valueAxis3.calculateTotals = true;

      // Create series
      function createSeriesProd(field, name, color) {
        
        // Set up series
        let series = chartProduccion.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "a";
        series.sequencedInterpolation = true;
        series.fill = am4core.color(color);
        series.tooltip.background.fill = am4core.color(color);
        // Make it stacked
        series.stacked = true;
        series.fillOpacity = 0.8;
        series.strokeWidth = 0;
        

        // Configure columns
        series.columns.template.width = am4core.percent(60);
        series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";

        return series;
      }

      for(var i=0; i<produccionVariables.length; i++)
      {
        let v = produccionVariables[i];
        createSeriesProd(v.id, v.nombre,v.color);
      }


      var totalSeriesProd = chartProduccion.series.push(new am4charts.ColumnSeries());
      totalSeriesProd.dataFields.valueY = "total";
      totalSeriesProd.dataFields.categoryX = "a";
      totalSeriesProd.stacked = true;
      totalSeriesProd.hiddenInLegend = true;
      totalSeriesProd.columns.template.strokeOpacity = 0;

      var totalBulletProd = totalSeriesProd.bullets.push(new am4charts.LabelBullet());
      totalBulletProd.dy = -10;
      totalBulletProd.label.text = "{valueY.total.formatNumber('#.0')}";
      totalBulletProd.label.hideOversized = false;
      totalBulletProd.label.fontSize = 10;
      totalBulletProd.label.fill = am4core.color("#333");
      totalBulletProd.label.background.fillOpacity = 0.2;
      totalBulletProd.label.padding(5, 5, 5, 5);

      // Legend
      chartProduccion.legend = new am4charts.Legend();
      chartProduccion.legend.useDefaultMarker = true;
      let marker3 = chartProduccion.legend.markers.template.children.getIndex(0);
      marker3.cornerRadius(12, 12, 12, 12);
      marker3.strokeWidth = 2;
      marker3.strokeOpacity = 1;
      marker3.stroke = am4core.color("#fff");

      this.chartProduccion = chartProduccion;

      //barrasProduccionUbicacion
      let chartProduccionUbicacion = am4core.create(this.$refs.barrasProduccionUbicacion, am4charts.XYChart);
      chartProduccionUbicacion.language.locale = am4lang_es_ES;
      chartProduccionUbicacion.language.locale["_decimalSeparator"] = ".";
      chartProduccionUbicacion.language.locale["_thousandSeparator"] = ",";
      chartProduccionUbicacion.exporting.menu = new am4core.ExportMenu();
      chartProduccionUbicacion.exporting.filePrefix = "ProduccionGas";
      chartProduccionUbicacion.exporting.useWebFonts = false;
      chartProduccionUbicacion.maskBullets = false;
      chartProduccionUbicacion.paddingLeft = 20;
      chartProduccionUbicacion.paddingRight = 50;
      chartProduccionUbicacion.fontSize = 12;

      chartProduccionUbicacion.data = produccionUbicacionDatos;

      // Create axes
      let categoryAxis4 = chartProduccionUbicacion.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis4.dataFields.category = "a";
      categoryAxis4.renderer.grid.template.location = 0;
      categoryAxis4.renderer.minGridDistance = 35;
      categoryAxis4.baseInterval = {
                    timeUnit: "year",
                    count: 5
      };

      let valueAxis4 = chartProduccionUbicacion.yAxes.push(new am4charts.ValueAxis());
      //valueAxis3.renderer.inside = true;
      //valueAxis3.renderer.labels.template.disabled = true;
      valueAxis4.title.text = "MMMPCD";
      valueAxis4.min = 0;
      valueAxis4.extraMax = 0.1;
      valueAxis4.calculateTotals = true;

      // Create series
      function createSeriesProdUbi(field, name, color) {
        
        // Set up series
        let series = chartProduccionUbicacion.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "a";
        series.sequencedInterpolation = true;
        series.fill = am4core.color(color);
        series.tooltip.background.fill = am4core.color(color);
        // Make it stacked
        series.stacked = true;
        series.fillOpacity = 0.8;
        series.strokeWidth = 0;
        

        // Configure columns
        series.columns.template.width = am4core.percent(60);
        series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";

        return series;
      }

      for(var i=0; i<produccionUbicacionVariables.length; i++)
      {
        let v = produccionUbicacionVariables[i];
        createSeriesProdUbi(v.id, v.nombre,v.color);
      }


      var totalSeriesProdUbicacion = chartProduccionUbicacion.series.push(new am4charts.ColumnSeries());
      totalSeriesProdUbicacion.dataFields.valueY = "total";
      totalSeriesProdUbicacion.dataFields.categoryX = "a";
      totalSeriesProdUbicacion.stacked = true;
      totalSeriesProdUbicacion.hiddenInLegend = true;
      totalSeriesProdUbicacion.columns.template.strokeOpacity = 0;

      var totalBulletProdUbicacion = totalSeriesProdUbicacion.bullets.push(new am4charts.LabelBullet());
      totalBulletProdUbicacion.dy = -10;
      totalBulletProdUbicacion.label.text = "{valueY.total.formatNumber('#.0')}";
      totalBulletProdUbicacion.label.hideOversized = false;
      totalBulletProdUbicacion.label.fontSize = 10;
      totalBulletProdUbicacion.label.fill = am4core.color("#333");
      totalBulletProdUbicacion.label.background.fillOpacity = 0.2;
      totalBulletProdUbicacion.label.padding(5, 5, 5, 5);

      // Legend
      chartProduccionUbicacion.legend = new am4charts.Legend();
      chartProduccionUbicacion.legend.useDefaultMarker = true;
      let marker4 = chartProduccionUbicacion.legend.markers.template.children.getIndex(0);
      marker4.cornerRadius(12, 12, 12, 12);
      marker4.strokeWidth = 2;
      marker4.strokeOpacity = 1;
      marker4.stroke = am4core.color("#fff");

      this.chartProduccionUbicacion = chartProduccionUbicacion;
        
    },
    beforeDestroy() {
      if (this.chartProduccionUbicacion) {
        this.chartProduccionUbicacion.dispose();
      }
      if (this.chartProduccion) {
        this.chartProduccion.dispose();
      }
    },
  }

  
const produccionDatos = [
  {"a":'1960',"prod":914},
  {"a":'1961',"prod":967},
  {"a":'1962',"prod":1001},
  {"a":'1963',"prod":1081},
  {"a":'1964',"prod":1307},
  {"a":'1965',"prod":1336},
  {"a":'1966',"prod":1432},
  {"a":'1967',"prod":1546},
  {"a":'1968',"prod":1558},
  {"a":'1969',"prod":1644},
  {"a":'1970',"prod":1817},
  {"a":'1971',"prod":1750},
  {"a":'1972',"prod":1785},
  {"a":'1973',"prod":1844},
  {"a":'1974',"prod":2022},
  {"a":'1975',"prod":2138},
  {"a":'1976',"prod":2105},
  {"a":'1977',"prod":2042},
  {"a":'1978',"prod":2554},
  {"a":'1979',"prod":2912},
  {"a":'1980',"prod":3540},
  {"a":'1981',"prod":4055},
  {"a":'1982',"prod":4231},
  {"a":'1983',"prod":4034},
  {"a":'1984',"prod":3746},
  {"a":'1985',"prod":3598},
  {"a":'1986',"prod":3429},
  {"a":'1987',"prod":3493},
  {"a":'1988',"prod":3467},
  {"a":'1989',"prod":3551},
  {"a":'1990',"prod":3637},
  {"a":'1991',"prod":3617},
  {"a":'1992',"prod":3563},
  {"a":'1993',"prod":3568},
  {"a":'1994',"prod":3612},
  {"a":'1995',"prod":3736},
  {"a":'1996',"prod":4184},
  {"a":'1997',"prod":4449},
  {"a":'1998',"prod":4781},
  {"a":'1999',"prod":4784},
  {"a":'2000',"prod":4670},
  {"a":'2001',"prod":4506},
  {"a":'2002',"prod":4407},
  {"a":'2003',"prod":4490},
  {"a":'2004',"prod":4563},
  {"a":'2005',"prod":4803},
  {"a":'2006',"prod":5354},
  {"a":'2007',"prod":6050},
  {"a":'2008',"prod":6910},
  {"a":'2009',"prod":7015},
  {"a":'2010',"prod":7003},
  {"a":'2011',"prod":6587},
  {"a":'2012',"prod":6365},
  {"a":'2013',"prod":6369},
  {"a":'2014',"prod":6526},
  {"a":'2015',"prod":6410},
  {"a":'2016',"prod":5710},
  {"a":'2017',"prod":5017},
  {"a":'2018',"prod":4812},
  {"a":'2019',"prod":4864},
  {"a":'2020',"prod":4818},
  {"a":'2021',"prod":4727},
  {"a":'2022',"prod":4724}
],
produccionVariables = [
  {"id":"prod","nombre":"Producción","color":"#d83b01"}
];

const produccionUbicacionDatos = [
  {a:'1960',Marino:0,Terrestre:914},
  {a:'1961',Marino:5,Terrestre:962},
  {a:'1962',Marino:14,Terrestre:987},
  {a:'1963',Marino:24,Terrestre:1057},
  {a:'1964',Marino:14,Terrestre:1293},
  {a:'1965',Marino:10,Terrestre:1326},
  {a:'1966',Marino:11,Terrestre:1421},
  {a:'1967',Marino:7,Terrestre:1539},
  {a:'1968',Marino:7,Terrestre:1551},
  {a:'1969',Marino:34,Terrestre:1610},
  {a:'1970',Marino:91,Terrestre:1726},
  {a:'1971',Marino:59,Terrestre:1691},
  {a:'1972',Marino:36,Terrestre:1749},
  {a:'1973',Marino:40,Terrestre:1804},
  {a:'1974',Marino:49,Terrestre:1973},
  {a:'1975',Marino:48,Terrestre:2090},
  {a:'1976',Marino:44,Terrestre:2061},
  {a:'1977',Marino:57,Terrestre:1985},
  {a:'1978',Marino:107,Terrestre:2447},
  {a:'1979',Marino:141,Terrestre:2771},
  {a:'1980',Marino:327,Terrestre:3213},
  {a:'1981',Marino:583,Terrestre:3472},
  {a:'1982',Marino:910,Terrestre:3321},
  {a:'1983',Marino:942,Terrestre:3092},
  {a:'1984',Marino:991,Terrestre:2755},
  {a:'1985',Marino:990,Terrestre:2608},
  {a:'1986',Marino:910,Terrestre:2519},
  {a:'1987',Marino:1012,Terrestre:2481},
  {a:'1988',Marino:1039,Terrestre:2428},
  {a:'1989',Marino:1110,Terrestre:2441},
  {a:'1990',Marino:1146,Terrestre:2491},
  {a:'1991',Marino:1193,Terrestre:2424},
  {a:'1992',Marino:1205,Terrestre:2358},
  {a:'1993',Marino:1278,Terrestre:2290},
  {a:'1994',Marino:1372,Terrestre:2240},
  {a:'1995',Marino:1407,Terrestre:2329},
  {a:'1996',Marino:1594,Terrestre:2590},
  {a:'1997',Marino:1678,Terrestre:2771},
  {a:'1998',Marino:1717,Terrestre:3064},
  {a:'1999',Marino:1602,Terrestre:3182},
  {a:'2000',Marino:1587,Terrestre:3083},
  {a:'2001',Marino:1563,Terrestre:2943},
  {a:'2002',Marino:1484,Terrestre:2923},
  {a:'2003',Marino:1555,Terrestre:2935},
  {a:'2004',Marino:1582,Terrestre:2981},
  {a:'2005',Marino:1616,Terrestre:3187},
  {a:'2006',Marino:1866,Terrestre:3488},
  {a:'2007',Marino:2282,Terrestre:3768},
  {a:'2008',Marino:3027,Terrestre:3883},
  {a:'2009',Marino:2976,Terrestre:4039},
  {a:'2010',Marino:2823,Terrestre:4180},
  {a:'2011',Marino:2680,Terrestre:3907},
  {a:'2012',Marino:2661,Terrestre:3704},
  {a:'2013',Marino:2792,Terrestre:3577},
  {a:'2014',Marino:3136,Terrestre:3390},
  {a:'2015',Marino:3335,Terrestre:3075},
  {a:'2016',Marino:3110,Terrestre:2600},
  {a:'2017',Marino:2882,Terrestre:2135},
  {a:'2018',Marino:2920,Terrestre:1892},
  {a:'2019',Marino:3029,Terrestre:1835},
  {a:'2020',Marino:3011,Terrestre:1807},
  {a:'2021',Marino:2850,Terrestre:1877},
  {a:'2022',Marino:2619,Terrestre:2105}
],
produccionUbicacionVariables = [
  {"id":"Marino","nombre":"Marino","color":"#0078d7"},
  {"id":"Terrestre","nombre":"Terrestre","color":"#ada11d"}
];


</script>
<style scoped lang="scss">
  
  
.barrasProduccion
{
  width: 100%;
  height: 500px;
}

.barrasProduccionUbicacion {
  width: 100%;
  height: 500px;
}



</style>
